import * as React from 'react'
import { HelpCircle } from 'lucide-react'
import { useTranslation } from '@/hooks/useTranslation'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'

/**
 * Compact `?` info trigger — shown next to the "Pick a source" eyebrow in
 * the connector picker. Hover or click to reveal the three-stage pipeline
 * explanation. Replaces the previous full-width strip; same content, much
 * less chrome.
 */
export const SourcesInfoPopover: React.FC = () => {
  const { t } = useTranslation('common')
  return (
    <Popover>
      <PopoverTrigger
        className="inline-flex size-4 items-center justify-center rounded-full text-muted-foreground transition-colors hover:text-foreground"
        aria-label={t('sources.howSourcesWork')}
        data-testid="tid.compass.howSourcesWork.trigger"
      >
        <HelpCircle className="size-3.5" />
      </PopoverTrigger>
      <PopoverContent
        side="right"
        align="start"
        className="w-72 text-xs leading-relaxed"
        data-testid="tid.compass.howSourcesWork"
      >
        <p className="text-foreground">{t('sources.intro')}</p>
        <ol className="mt-2 space-y-1 text-muted-foreground">
          <li>
            <span className="font-medium text-foreground">{t('sources.stepConnect')}</span>
            {t('sources.stepConnectSuffix')}
          </li>
          <li>
            <span className="font-medium text-foreground">{t('sources.stepExtract')}</span>
            {t('sources.stepExtractSuffix')}
          </li>
          <li>
            <span className="font-medium text-foreground">{t('sources.stepReview')}</span>
            {t('sources.stepReviewSuffix')}
          </li>
        </ol>
        <p className="mt-2 text-[11px] text-muted-foreground">{t('sources.reimportNote')}</p>
      </PopoverContent>
    </Popover>
  )
}
